import { useState, useEffect, useCallback } from 'react';
/**
 * Hook for managing modal open/close state with keyboard shortcuts.
 */
export function useModalTrigger() {
    const [isOpen, setIsOpen] = useState(false);
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    // Global keyboard shortcut: Cmd+K / Ctrl+K / '/'
    useEffect(() => {
        const isInputElement = (target) => {
            if (!target || !(target instanceof HTMLElement))
                return false;
            const tagName = target.tagName.toLowerCase();
            return tagName === 'input' || tagName === 'textarea' || target.isContentEditable;
        };
        const handleKeyDown = (event) => {
            // Skip if inside input/textarea
            if (isInputElement(event.target))
                return;
            // Cmd+K or Ctrl+K
            if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
                event.preventDefault();
                open();
            }
            // '/' key (but not when combined with modifiers)
            if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                event.preventDefault();
                open();
            }
            // Escape to close
            if (event.key === 'Escape' && isOpen) {
                event.preventDefault();
                close();
            }
        };
        // Listen for custom event from header icon
        const handleCustomEvent = () => open();
        window.addEventListener('eno-search:open', handleCustomEvent);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('eno-search:open', handleCustomEvent);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, open, close]);
    return {
        isOpen,
        open,
        close,
    };
}
